import styled from "@emotion/styled";

export const alterElementOnImgErr = `
    <div class="--img-render-error">
        <i class="--img-render-error-icon">lightbulb</i>
        <p>Failed to load image </p>
    </div>
`;

export const StyledImgWrapper = styled.div`
  .--img-render-error {
    display: flex;
    flex-direction: column;
    align-items: center;

    .--img-render-error-icon {
      font-family: "Material Icons Outlined";
      font-size: 7rem;
      font-style: normal;
    }
  }
`;
